class FeaturedQuoteV2 extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-quote-panel]'));
    this.buttons = Array.from(this.querySelectorAll('[data-quote-trigger]'));
    if (this.panels.length === 0 || this.buttons.length === 0) return;

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quote-trigger]');
      if (button && this.contains(button)) this.select(button);
    });
  }

  select(button) {
    if (button.getAttribute('aria-pressed') === 'true') return;

    const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
    if (!panel) return;

    this.panels.forEach((item) => {
      item.hidden = item !== panel;
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease' });
    }

    this.buttons.forEach((other) => {
      const active = other === button;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('featured-quote-v2')) {
  customElements.define('featured-quote-v2', FeaturedQuoteV2);
}
